import { SET_DRAFT_ORDERS, SET_ORDERS, SET_ORDERS_DETAIL, SET_PRODUCTS, SET_RFQ, SET_STATUS, SET_VALUE } from "../ConstAction";

const initialState = {};
export const CartData = (state = initialState, action) => {

  switch (action.type) {

    case SET_DRAFT_ORDERS:
      return {
        ...state,
        orders: action.response.data.data,
      };
    case SET_ORDERS:
      return {
        ...state,
        allorders: action.response.data.data,
      };
    case SET_ORDERS_DETAIL:
      return {
        ...state,
        ordersDetails: action.response,
      };
    case SET_RFQ:
      return {
        ...state,
        rfq: action.response.data.data,
      };
    case SET_STATUS:
      return {
        ...state,
        Statuses: action.response.data.data,
      };
    case SET_VALUE:
      return {
        ...state,
        value: action.response.data,
      };
    default:
      return { ...state };
  }
};
